import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tooltip, { ALIGN, POSITION } from 'gnos-tooltip'
import moment from 'moment'
import cx from 'classnames'
import _ from 'lodash'

import TooltipContent from '../TooltipContent'

export default class InactiveDate extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object.isRequired,
        endDate: PropTypes.string,
        handleOnHover: PropTypes.func.isRequired,
        index: PropTypes.string.isRequired,
        mainId: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        pinnedIndex: PropTypes.string,
        pinParticipationElement: PropTypes.func.isRequired,
        startDate: PropTypes.string,
        timelineDurationInDays: PropTypes.number,
        timelineEndDate: PropTypes.object,
        timelineStartDate: PropTypes.object,
        translates: PropTypes.shape({
            from: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            to: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    handleOnMouse = (attributes) => () => {
        this.props.handleOnHover(attributes)
    }

    handleOnClick = (attributes) => () => {
        const { module, block, customData, index, pinParticipationElement, mainId } = this.props
        this.props.handleOnHover(attributes, true)

        const currentPinnedIndex = _.get(customData, 'pinnedIndex', null)

        const newCustomData = {
            pinnedIndex: currentPinnedIndex === index ? null : index,
        }

        pinParticipationElement(module, mainId, block, newCustomData)
    }

    // Inactive, we know startDate, missing endDate
    // Triangle facing left
    // Open on the right
    renderRightOpenDate = () => {
        const { startDate, timelineStartDate, timelineDurationInDays, index, name, translates } = this.props

        // Get difference between the start of the timeline and the start of the element in days (based on startDates)
        const elementMargin = moment(startDate).diff(timelineStartDate, 'days')
        // Get position of element on timeline (percentage)
        const left = (elementMargin / timelineDurationInDays) * 100

        return (
            <Tooltip
                id={`participation-tooltip-${index}`}
                content={<TooltipContent startDate={startDate} endDate={null} name={name} translates={translates} />}
                width={'125px'}
                align={ALIGN.CENTER}
                position={POSITION.TOP}
                style={{ textAlign: 'center' }}
            >
                <div className={cx('arrow-icon', 'time-arrow-left')} style={{ left: `${left}%` }} />
            </Tooltip>
        )
    }

    // Inactive, we know endDate, missing startDate
    // Triangle facing right
    // Open on the left
    renderLeftOpenDate = () => {
        const { endDate, translates, timelineEndDate, timelineDurationInDays, index, name } = this.props

        // Get difference between the start of the timeline and the start of the element in days (based on startDates)
        const elementMargin = timelineEndDate.diff(moment(endDate), 'days')
        // Get position of element on timeline (percentage)
        const right = (elementMargin / timelineDurationInDays) * 100

        return (
            <Tooltip
                id={`participation-tooltip-${index}`}
                content={<TooltipContent startDate={null} endDate={endDate} name={name} translates={translates} />}
                width={'125px'}
                align={ALIGN.CENTER}
                position={POSITION.TOP}
                style={{ textAlign: 'center' }}
            >
                <div className={cx('arrow-icon', 'time-arrow-right')} style={{ right: `${right}%` }} />
            </Tooltip>
        )
    }

    render() {
        const { startDate, endDate, timelineDurationInDays, timelineStartDate, index, pinnedIndex, name, translates } =
            this.props

        if (!endDate) return this.renderRightOpenDate() // Only from date, triangle open on right side
        if (!startDate) return this.renderLeftOpenDate() // Only to date, triangle open on left side

        // Classic interval from - to
        // Inactive

        // Get difference between the start of the timeline and the start of the element in days (based on startDates)
        const elementMargin = moment(startDate).diff(timelineStartDate, 'days')
        // Get the difference between the element's startDate and endDate in days - width of the element "in days"
        const elementWidth = moment(endDate).diff(moment(startDate), 'days')

        const widthInPercentage = (elementWidth / timelineDurationInDays) * 100
        const width = widthInPercentage > 0 ? widthInPercentage : 1

        const left = (elementMargin / timelineDurationInDays) * 100

        return (
            <div
                onMouseEnter={this.handleOnMouse({ width, left })}
                onMouseLeave={this.handleOnMouse({})}
                onClick={this.handleOnClick({ width, left })}
            >
                <Tooltip
                    id={`participation-tooltip-${index}`}
                    content={
                        <TooltipContent startDate={startDate} endDate={endDate} name={name} translates={translates} />
                    }
                    width={'125px'}
                    align={ALIGN.CENTER}
                    position={POSITION.TOP}
                    style={{ textAlign: 'center' }}
                >
                    <div
                        style={{ left: `${left}%`, width: `${width}%` }}
                        className={cx('participation-element', 'inactive', pinnedIndex === index ? 'pinned' : 'pin')}
                    >
                        <div className={cx('pin-icon')} />
                    </div>
                </Tooltip>
            </div>
        )
    }
}
